import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { IMembershipDetailResponse, IMembershipDetailResponseData } from "@/api_framework/api_modals/Membership";

AxiosCurlirize(axios, () => {});

export const useMembershipDetailsAPI = () => {
  const [membershipDetails, setMembershipDetails] = useState<IMembershipDetailResponseData>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (membership_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${MEMBERSHIP_MODULE?.MEMBERSHIP_DETAIL?.baseURL}/${membership_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipDetailResponse>) => {
            if (res.data.status) {
              setMembershipDetails(res.data.data);
            } else {
              setMembershipDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setMembershipDetails(null);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setMembershipDetails(null);
      }
    },
    [dispatch],
  );
  return { execute, membershipDetails };
};
